import { SelectPriority } from "./SelectPriority.js";
import "react";
import { jsx } from "react/jsx-runtime";
import { Field, useFormikContext } from "formik";
//#region src/components/Priority/FormikSelectPriority.tsx
var FormikSelectPriority = (props) => {
	const form = useFormikContext();
	return /* @__PURE__ */ jsx(Field, {
		name: props.name,
		children: ({ field, meta }) => {
			return /* @__PURE__ */ jsx(SelectPriority, {
				...props,
				error: (meta.touched || !!form.submitCount) && meta.error,
				valid: (meta.touched || !!form.submitCount) && meta.value && !meta.error,
				onChangeValue: (value) => props.name && form.setFieldValue(props.name, value),
				...field,
				onChange: null
			});
		}
	});
};
//#endregion
export { FormikSelectPriority };

//# sourceMappingURL=FormikSelectPriority.js.map